import { api } from "./config.js";

const getMenusEndpoint = (branchId) => {
  const baseURL = api.defaults.baseURL || "";
  const prefix = baseURL.replace(/\/$/, "").endsWith("/api") ? "" : "/api";

  return `${prefix}/app/getMenusByBranch/${branchId}`;
};

export const getMenusByBranch = async (branchId) => {
  const response = await api.get(getMenusEndpoint(branchId));
  return response.data;
};

const getMenuCategoriesEndpoint = (branchId) => {
  const baseURL = api.defaults.baseURL || "";
  const prefix = baseURL.replace(/\/$/, "").endsWith("/api") ? "" : "/api";

  return `${prefix}/app/getMenuCategoriesByBranch/${branchId}`;
};

const normalizeCategories = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.menucategories)) {
    return payload.menucategories;
  }

  if (Array.isArray(payload?.data?.menucategories)) {
    return payload.data.menucategories;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export const getMenuCategoriesByBranch = async (branchId) => {
  const response = await api.get(getMenuCategoriesEndpoint(branchId));
  return normalizeCategories(response.data);
};
